import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { ModalProvider } from './context/ModalContext';
import ModalRoot from './components/modals/ModalRoot';
import { Toaster } from 'sonner';

document.documentElement.classList.remove('dark');
localStorage.removeItem('theme_mode');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SocketProvider>
        <ModalProvider>
          <BrowserRouter>
            <App />
            <ModalRoot />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </ModalProvider>
      </SocketProvider>
    </AuthProvider>
  </React.StrictMode>
);
